import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { SourcingTemplateDTORuntype, SourcingTemplateInputDTORuntype } from './sourcingTemplateBackendTypes';

export const sourcingTemplateEndpoints = {
    'GET /sourcing-templates': endpoint({
        description: 'Retrieve a list of sourcing templates',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            items: z.array(SourcingTemplateDTORuntype),
        }),
    }),
    'POST /sourcing-templates': endpoint({
        description: 'Create a new sourcing template',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: SourcingTemplateInputDTORuntype,
        responseBody: SourcingTemplateDTORuntype,
        invalidates: ['GET /sourcing-templates', 'GET /sourcing-templates/:id'],
    }),
    'GET /sourcing-templates/:id': endpoint({
        description: 'Retrieve a single sourcing template',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: SourcingTemplateDTORuntype,
    }),
    'PATCH /sourcing-templates/:id': endpoint({
        description: 'Edit a sourcing template',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: SourcingTemplateInputDTORuntype,
        responseBody: SourcingTemplateDTORuntype,
        invalidates: ['GET /sourcing-templates', 'GET /sourcing-templates/:id'],
    }),
    'DELETE /sourcing-templates/:id': endpoint({
        description: 'Delete a sourcing template',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.null(),
        invalidates: ['GET /sourcing-templates', 'GET /sourcing-templates/:id'],
    }),
};
